export function isWebView(): boolean {
  return /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)|Android.*(wv|.0.0.0)|WebView|Linux; U; Android/i.test(navigator.userAgent) && navigator.maxTouchPoints > 1
}

export function isAndroidWebview(): boolean {
  return /Zalo android/.test(navigator.userAgent) && navigator.maxTouchPoints > 1
}

export function isIOSWebview(): boolean {
  return /Zalo iOS/.test(navigator.userAgent) && navigator.maxTouchPoints > 1
}